var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring-tunnel";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"-P0SydzaIFn8bDF9Q9tsK"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'

const enabled = process.env.NEXT_PUBLIC_SENTRY_ENABLNED === 'true' || process.env.NEXT_PUBLIC_ENVIRONMENT !== 'local'

const options = {
  production: {
    maxBreadcrumbs: 25,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  },
  local: {
    maxBreadcrumbs: 100,
    tracesSampleRate: 1,
    replaysSessionSampleRate: 1,
    replaysOnErrorSampleRate: 1,
  },
  stage: {
    maxBreadcrumbs: 50,
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  },
  development: {
    maxBreadcrumbs: 25,
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  },
}[process.env.NEXT_PUBLIC_ENVIRONMENT] || {
  maxBreadcrumbs: 20,
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
}

Sentry.init({
  enabled,
  dsn: 'https://c96c9b842aa94de382520b6db94baffd@o655834.ingest.sentry.io/4504201648603136',
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,

  maxBreadcrumbs: enabled ? options.maxBreadcrumbs : 20,
  tracesSampleRate: enabled ? options.tracesSampleRate : 0,
  // Replay may only be enabled for the client-side
  integrations: [new Sentry.Replay()],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: enabled ? options.replaysSessionSampleRate : 0,
  replaysOnErrorSampleRate: enabled ? options.replaysOnErrorSampleRate : 0,

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
